import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal, Button } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import JoditEditor from "jodit-react";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { getData, IMG_URL, postData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/admin/products/rating/${id}`);
    reset(response?.data);
    setData(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    reset,
  } = useForm();

  const [data, setData] = useState({});

   const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowImageModal(true);
  };

  const handleImageModalClose = () => {
  setSelectedImage(null);
};

  const onSubmit = async (data) => {
    try {
      // const sendData = new FormData();
      // sendData.append("response", data?.name);
      const response = await postData(`/product/ratings/${id}`, data);

      if (response?.success) {
        setData(response?.data);
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({
          code: response?.code,
          message: response?.message,
        });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Review</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="justify-content-center">
              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Review</Form.Label>
                    </div>
                    <div className="border-line mt-3"></div>
                    <div className="d-flex flex-wrap">
                      <Col md={4}>
                        <p>
                          <strong>By :- </strong>
                          {data?.User?.name} {data?.User?.last_name}
                        </p>
                      </Col>

                      <Col md={4}>
                        <p>
                          <strong>Email :- </strong>
                          {data?.User?.email}
                        </p>
                      </Col>

                      <Col md={4}>
                        <p>
                          <strong>Contact :- </strong>
                          {data?.User?.contact_no}
                        </p>
                      </Col>
                    </div>
                    <div className="heading-holder">
                      <h6>Product Details</h6>
                    </div>

                    <div className="package-details-section">
                      <div className="pending-table">
                        <div className="d-flex align-items-center flex-wrap">
                          {/* Product Image */}
                          <div className="text-center ms-3 me-4">
                            <Form.Label>Product Image</Form.Label>

                            {data?.Product?.image ? (
                              <div>
                                <img
                                  src={IMG_URL + data.Product.image}
                                  alt={data?.Product?.name || "Product"}
                                  onClick={() =>
                                    handleImageClick(
                                      IMG_URL + data.Product.image,
                                    )
                                  }
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                    border: "1px solid #ddd",
                                  }}
                                />
                              </div>
                            ) : (
                              <p>No Image</p>
                            )}
                          </div>

                          {/* Product Name */}
                          <div className="text-center ms-4 me-4">
                            <Form.Label>Name</Form.Label>
                            <p>{data?.Product?.name}</p>
                          </div>

                          {/* Brand */}
                          <div className="text-center ms-4 me-4">
                            <Form.Label>Brand</Form.Label>
                            <p>{data?.Product?.Brand?.name}</p>
                          </div>
                        </div>

                        {/* Rating Images */}
                        <div className="mt-4">
                          <Form.Label>Review Images</Form.Label>

                          <div className="d-flex flex-wrap gap-3 mt-2">
                            {data?.Rating_Images?.filter(
                              (img) => !img?.deletedAt,
                            )?.length > 0 ? (
                              data.Rating_Images.filter(
                                (img) => !img?.deletedAt,
                              ).map((img, index) => (
                                <div
                                  key={img?.id || index}
                                  className="text-center"
                                >
                                  <img
                                    src={IMG_URL + img?.image}
                                    alt={`Review Image ${index + 1}`}
                                    onClick={() =>
                                      handleImageClick(IMG_URL + img?.image)
                                    }
                                    style={{
                                      width: "120px",
                                      height: "120px",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                      border: "1px solid #ddd",
                                    }}
                                  />

                                  <p className="mt-1 mb-0 text-muted">
                                    Image {index + 1}
                                  </p>
                                </div>
                              ))
                            ) : (
                              <p className="text-muted">
                                No review images uploaded.
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="d-flex flex-colomn mt-4">
                      <Col md={8}>
                        <p>
                          <b>{getValues("title")}</b>
                        </p>
                        <p>{getValues("review")}</p>
                      </Col>
                      <Col md={4}>
                        <img
                          src={IMG_URL + getValues("image")}
                          style={{ width: "10%" }}
                        />
                      </Col>
                    </div> */}
                  </Form.Group>
                  {/* <Button style={{ backgroundColor: "white" }}>
                    <Link
                      to={`/order-managements/single-order/${getValues("order_id")}`}
                      className=" text-decoration-none  "
                    >View Order
                    </Link>
                  </Button> */}
                </div>
              </Col>

              {/* <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    {" "}

                    <Col sm={12}>
                      <Form.Label className="text-center">
                        Reply
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="response" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{
                            required: "Reply is required",
                          }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={field.value}
                              onChange={(newContent) =>
                                field.onChange(newContent)
                              }
                              onBlur={field.onBlur}
                              className={classNames("", {
                                "is-invalid": !!errors.description,
                              })}
                              placeholder="reply...."
                            />
                          )}
                        />
                      </Form.Group>
                      {errors.response && (
                        <span className="text-danger">
                          {errors.response.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col> */}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"Close"}
                      handleClose={props.handleClose}
                    />
                  </Link>
                  {/* <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  /> */}
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>


      <Modal
        show={!!selectedImage}
        onHide={handleImageModalClose}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="d-flex justify-content-center align-items-center"
          style={{
            minHeight: "500px",
            backgroundColor: "#f8f8f8",
          }}
        >
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Full Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "600px",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
            />
          )}
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" onClick={handleImageModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
